// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"08233d16","201":"08233d16","489":"08233d16"}[chunkId] + ".chunk.css";
};